<div class="md:tw-w-full tw-px-0">
  @if (alertMessage) {
    <div class="tw-my-3">
      <cohrex-alert
        [visible]="$safeNavigationMigration(alertMessage?.visible)"
        [color]="alertMessage.type"
        (closeAlert)="handleAlertClosed()"
      >
        {{ alertMessage.message }}
      </cohrex-alert>
    </div>
  }
  <div class="tw-relative tw-overflow-x-auto">
    <table
      class="tw-w-full tw-tw-text-sm tw-text-left tw-text-gray-500 dark:tw-text-gray-400"
      aria-describedby="Cohrex Table"
    >
      <thead
        class="tw-text-xs tw-uppercase tw-g-white tw-border-b tw-border-neutral-500"
      >
        <tr>
          @for (header of data?.headers; track header) {
            <th scope="col" class="tw-px-6 tw-py-3 tw-text-neutral-800">
              <div class="tw-flex tw-items-center">
                <span>{{ header.displayName | translate }}</span>
                @if (header.sortable) {
                  <cohrex-button
                    color="primaryLink"
                    className="tw-py-0 tw-px-0 tw-text-sm"
                    (click)="sortColumn(header.columnId)"
                  >
                    <div class="material-icons">
                      {{
                        sortType === 'desc'
                          ? 'keyboard_arrow_down'
                          : 'keyboard_arrow_up'
                      }}
                    </div></cohrex-button
                  >
                }
              </div>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @if (loading) {
          @for (item of [1, 2]; track item) {
            <tr>
              @for (item of data?.headers; track item; let first = $first) {
                @if (first) {
                  <th class="tw-px-6 tw-py-4" id="1">
                    <cohrex-skeleton-loader
                      [rounded]="'tw-rounded-sm'"
                    ></cohrex-skeleton-loader>
                  </th>
                } @else {
                  <td class="tw-px-6 tw-py-4">
                    <cohrex-skeleton-loader
                      [rounded]="'tw-rounded-sm'"
                    ></cohrex-skeleton-loader>
                  </td>
                }
              }
            </tr>
          }
        } @else {
          @if (data?.items.length > 0) {
            @for (item of data?.items; track item; let last = $last) {
              <tr
                class="tw-bg-white {{
                  !last ? 'tw-border-b' : 'tw-border-b-0'
                }} border-neutral-200 parent-tr"
                [attr.data]="stringifyObject(item)"
              >
                @for (
                  header of data?.headers;
                  track header;
                  let first = $first
                ) {
                  @if (first) {
                    <th
                      scope="row"
                      class="tw-px-6 tw-py-4 tw-font-medium tw-text-neutral-800 tw-whitespace-nowrap"
                    >
                      <div>{{ item[header.columnId] ?? '-' }}</div>
                    </th>
                  } @else {
                    <td class="tw-px-6 tw-py-4 tw-text-neutral-800">
                      @if (header.columnId !== 'action') {
                        @if (item[header.columnId]?.class) {
                          <div class="{{ item[header.columnId]?.class }}">
                            {{ item[header.columnId]?.value ?? '-' }}
                          </div>
                        } @else {
                          {{ item[header.columnId] ?? '-' }}
                        }
                      } @else {
                        <div class="tableActions"></div>
                        <ng-container
                          *ngTemplateOutlet="
                            actionTemplate;
                            context: { item: item }
                          "
                        ></ng-container>
                      }
                    </td>
                  }
                }
              </tr>
            }
          } @else {
            <tr>
              <td [attr.colspan]="data?.headers?.length">
                <div
                  class="tw-w-full tw-p-8 tw-bg-white tw-flex-col tw-justify-center tw-items-center tw-inline-flex"
                >
                  <div class="tw-w-full tw-relative tw-flex tw-justify-center">
                    <cohrex-svg name="empty-box"></cohrex-svg>
                  </div>
                  <div
                    class="tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-flex mb-5"
                  >
                    <div class="tw-text-neutral-800 tw-text-lg tw-normal-case">
                      {{ 'app.no_resource' | translate: translatedResource }}
                    </div>
                    <div
                      class="tw-text-center tw-text-neutral-600 tw-text-base"
                    >
                      {{
                        'app.table_no_resource' | translate: translatedResource
                      }}.
                      @if (canCreate) {
                        <span>{{ 'app.create_resource' | translate }}</span>
                      }
                    </div>
                  </div>
                  @if (canCreate) {
                    <cohrex-button startIcon="add" (click)="addResource.emit()">
                      {{ 'app.add' | translate }}
                      {{ resource | translate }}</cohrex-button
                    >
                  }
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
  @if (data?.items?.length > 0 && !!paginationData) {
    <div class="tw-mt-10">
      <cohrex-pagination
        [paginationData]="paginationData"
        (pageChanged)="handlePageChanged($event)"
      ></cohrex-pagination>
    </div>
  }
</div>
